import React from "react";

const ChevronRightSmallIcon: React.FC = () => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.26399 6.26361C8.91252 6.61508 8.91252 7.18493 9.264 7.5364L13.7276 12L9.26399 16.4636C8.91252 16.8151 8.91252 17.3849 9.264 17.7364C9.61547 18.0879 10.1853 18.0879 10.5368 17.7364L15.6368 12.6364C15.9883 12.2849 15.9883 11.715 15.6368 11.3636L10.5368 6.2636C10.1853 5.91213 9.61546 5.91213 9.26399 6.26361Z"
        fill="currentColor"
      />
    </svg>
  );

export default ChevronRightSmallIcon;
